<template>
	<c-modal @close="close" :title="title">

		<c-form ref="form" @valid="submit" class="margin-t-40">

			<div v-if="!edit">
				<div class="c-form-element c-form-element--horizontal no-margin-b">
					<div class="c-form-element__label no-margin-t">
						<label>Voornaam</label>
					</div>
					<div class="c-form-element__container c-form-element__container--text">
						{{contact.first_name}}
					</div>
				</div>

				<div class="c-form-element c-form-element--horizontal no-margin-b">
					<div class="c-form-element__label no-margin-t">
						<label>Achternaam</label>
					</div>
					<div class="c-form-element__container c-form-element__container--text">
						{{contact.last_name}}
					</div>
				</div>

				<div class="c-form-element c-form-element--horizontal no-margin-b">
					<div class="c-form-element__label no-margin-t">
						<label>Functie</label>
					</div>
					<div class="c-form-element__container c-form-element__container--text">
						{{contact.title}}
					</div>
				</div>
			</div>

			<div class="margin-t-24">
				<c-input
					:label="'Contactpersoon'"
					:horizontal="true"
					type="text"
					name="contactpersoon"
					v-model="contactpersoon"
					required/>
					
				<c-input
					:label="'E-mailadres'"
					:horizontal="true"
					type="text"
					name="email"
					v-model="email"
					required/>

				<c-input
					:label="'Telefoonnummer'"
					:horizontal="true"
					type="text"
					name="phone"
					v-model="phone"
					required/>
			</div>

			<h6 class="margin-t-40">Voorraad</h6>

			<c-checkbox
			id="pickup-articles"
			v-model="pickupArticles"
			:horizontal="true"
			:label="'Op te halen'"
			:labeltext="'product.name'"
			:options="items"
			:ValueName="'id,product_id'">
			</c-checkbox>

			<div class="margin-t-40">
				<c-datepicker
					:label="'Ophaaldatum'"
					:horizontal="true"
					:icon="true"
					name="date"
					v-model="datePickup"
					:type="'future'">
				</c-datepicker>
			</div>

            <c-custom-zipcode-address
                :label="'Ophaallocatie'"
                :addresses="addresses"
                v-model="pickUpAddress"
                name="address"
            />

			<c-input
				label="Ordernummer"
				:horizontal="true"
				name="orderNumber"
				v-model="orderNumber"
				required
			/>

			<c-input
				label="Uw referentie"
				:horizontal="true"
				name="yourReference"
				v-model="yourReference"
				required
			/>

			<c-textarea
				:label="'Opmerking'"
				:horizontal="true"
				type="textarea"
				name="description"
				v-model="description"
			/>

			<div class="row collapse align-right">
				<div class="columns shrink">
					<c-button class="margin-t-32 margin-b-16 no-margin-b" type="submit">Bevestigen</c-button>
				</div>
			</div>

		</c-form>

	</c-modal>
</template>

<script>

import Form from '@mixins/Form';
import CModal from '@components/Modal';
import CDatepicker from '@components/form/input/Datepicker';
import { ValidationError } from '@app/errors';
import CCustomZipcodeAddress from '@components/CustomZipcodeAddress.vue';

export default {
	mixins: [Form],
	components: {
		CModal,
		CDatepicker,
		CCustomZipcodeAddress,
	},
	data() {
		return {
			pickUpAddress: {},
			pickupArticles: [],
			datePickup: '',
			orderNumber: '',
			yourReference: '',
			contactpersoon: '',
			description: '',
			email: '',
			phone: ''
		};
	},
	props: {
		addresses: {
			required: true,
			type: Array,
		},
		contacts: {
			required: true,
		},
		contact: {
			required: false,
		},
		items: {
			required: true
		},
		delivery: {
			required: false
		},
		edit: {
			required: false,
		},
		title: {
			required: false,
			default: 'Uitdiensttreding'
		}
	},
	methods: {
		submit() {

			let submitData = {
				address: this.pickUpAddress,
				date: this.datePickup,
				pickupArticles: this.pickupArticles,
				delivery_type_id: this.$constants.delivery.UITDIENST,
				order_number: this.orderNumber,
				your_reference: this.yourReference,
				contact: this.contactpersoon,
				description: this.description,
				contact_email: this.email,
				contact_phone: this.phone
			}

			let ItemsData = {
				items: []
			};

			this.pickupArticles.forEach( (component, index) => {
				let item = '';
				item = this.pickupArticles[index].split(' ');
				ItemsData['items'][index] = {item_id: item[0], product_id: item[1], is_pickup: 1};
			});
			let data = Object.assign(submitData, ItemsData);

			if(this.edit){
				data.client_id = this.contact;
				this.$xhr.put('/api/deliveries/' + this.delivery.id, data).then( ( {result}) => {
					this.close();
					this.$emit('added');
					this.$store.dispatch('toast/success', {title: 'Levering wijzigen', text: 'De levering is gewijzigd'});
				}).catch( (e) => {
                    if (e instanceof ValidationError) {
                        this.$refs.form.setErrors(e.errors);
                    }
					this.$store.dispatch('toast/alert', {title: 'Levering wijzigen', text: 'Er is helaas iets fout gegaan bij wijzigen'});
				});
			}
			else
			{
				data.client_id =  this.contact.client_id;
				data.carrier_id= 1;
				this.$xhr.post('/api/deliveries', data).then( ( {result}) => {
					this.close();
					this.$refs.form.reset();
					this.$store.dispatch('toast/success', {title: 'Levering aanmaken', text: 'De levering is aangemaakt'});
				}).catch( (e) => {
                    if (e instanceof ValidationError) {
                        this.$refs.form.setErrors(e.errors);
                    }
					this.$store.dispatch('toast/alert', {title: 'Levering aanmaken', text: 'Er is helaas iets fout gegaan bij het verzoek uitdiensttreding'});
				});
			}
		},
		close() {
			this.$emit('close');
		},
	},
	mounted() {
		if(this.edit)
		{
			this.datePickup = this.delivery.date;
			this.delivery.items.forEach((component, index) =>{
				let item = this.delivery.items[index].id + " " + this.delivery.items[index].product.id
				this.pickupArticles.push(item);
			});
			this.pickUpAddress = this.delivery.address;
			this.orderNumber = this.delivery.order_number;
			this.yourReference = this.delivery.your_reference;
			this.contactpersoon = this.delivery.contact;
			this.email = this.delivery.contact_email;
			this.phone = this.delivery.contact_phone;
			this.description = this.delivery.description
		}
		else{
			this.items.forEach((component, index) =>{
				let item = this.items[index].id + " " + this.items[index].product.id
				this.pickupArticles.push(item);
			});

		}
	}
}
</script>
